import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import { useQuery } from 'react-apollo';

import PrintProductConfigurator from '../../components/PrintProductConfigurator';
import useIsNativeWebView from '../../../native-bridge/hooks/useIsWebView';
import {
  postNativeAppPrintProductConfiguratorComplete,
  postNativeAppPrintProductConfiguratorDismiss,
} from '../../../native-bridge/native-apps-interface';
import getLogger from '../../../../util/logger';
import { Photo as PhotoQuery } from '../../../../graphql/queries/albums';
import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import { getPhotoOrientation } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/PrintProductsGroup/helpers';
import { CARD_ELEMENT_TYPE } from '../../../cards/constants';

const log = getLogger('StandalonePrintProductConfigurator');

const StandalonePrintProductConfigurator = () => {
  const { printProductId } = useParams();
  const location = useLocation();
  const isNativeWebView = useIsNativeWebView();
  const { printProductSizeId, photoId, assetImageId, existingAssetImageId } =
    qs.parse(location.search);

  const { data: { photo, loading } = {} } = useQuery(PhotoQuery, {
    variables: {
      id: photoId,
    },
    skip: !photoId,
  });

  if (
    !assetImageId &&
    !existingAssetImageId &&
    !photoId &&
    (!photo || loading)
  ) {
    return <FullScreenLoader />;
  }

  return (
    <PrintProductConfigurator
      printProductId={printProductId}
      printProductSizeId={printProductSizeId}
      availablePrintProductSizeIds={
        printProductSizeId ? [printProductSizeId] : undefined
      }
      controlsDisabled={!!printProductSizeId}
      photo={photo}
      orientation={photo ? getPhotoOrientation(photo) : undefined}
      presetCardElementConfigurationInputs={
        assetImageId || existingAssetImageId
          ? [
              {
                cardElement: {
                  type: CARD_ELEMENT_TYPE.PHOTO,
                },
                cardElementConfiguration: {
                  asset_image_id: assetImageId,
                  existing_asset_image_id: existingAssetImageId,
                },
              },
            ]
          : undefined
      }
      onClose={
        isNativeWebView
          ? () => {
              postNativeAppPrintProductConfiguratorDismiss();
            }
          : undefined
      }
      onComplete={({ accountCard, albumCustomPrint, printProduct }) => {
        log.info('onComplete :: ', {
          accountCard,
          albumCustomPrint,
          printProduct,
        });

        if (isNativeWebView) {
          postNativeAppPrintProductConfiguratorComplete({
            accountCard,
            albumCustomPrint,
            printProduct,
          });
        }
      }}
    />
  );
};

export default StandalonePrintProductConfigurator;
